import { render, staticRenderFns } from "./OrderAttributeLogDialog.vue?vue&type=template&id=8f66dc5c&"
import script from "./OrderAttributeLogDialog.vue?vue&type=script&lang=js&"
export * from "./OrderAttributeLogDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports